import { render, staticRenderFns } from "./CreateMdt.vue?vue&type=template&id=79f5da74&scoped=true"
import script from "./CreateMdt.vue?vue&type=script&lang=js"
export * from "./CreateMdt.vue?vue&type=script&lang=js"
import style0 from "./CreateMdt.vue?vue&type=style&index=0&id=79f5da74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5da74",
  null
  
)

export default component.exports